import React from 'react'
import { StyledTD } from '../../../styles/Components/Table'

export default function ({ item }) {
  return <StyledTD>{item.name}</StyledTD>
}
